<template>
  <div class="form-page">
    <div class="form-page__header">
      <h2 class="form-page__title">Datenschutz</h2>
      <p class="form-page__subtitle">* Pflichtfelder</p>
    </div>

    <div class="form-section">
      <div class="info-box info-box--blue">
        <span class="info-box__icon">🔒</span>
        <div>
          Bitte beachten Sie die <strong>Datenschutzerklärung</strong>. Hier können Sie insbesondere einsehen, auf welcher Grundlage die Daten für Ihren Antrag erhoben und verarbeitet werden, was der Verwendungszweck ist, wer die verantwortlichen Stellen für die Datenverarbeitung sind und welche Rechte Sie haben.
        </div>
      </div>
    </div>

    <div class="form-section">
      <div class="legal-block">
        <h3 class="legal-block__title">Verantwortliche Stelle</h3>
        <p>Landesamt für Einwanderung Berlin (LEA)<br/>
        Keplerstraße 2, 10589 Berlin<br/>
        Telefon: (030) 90269-0<br/>
        E-Mail: info@lea.berlin.de</p>
      </div>

      <div class="legal-block">
        <h3 class="legal-block__title">Zweck der Datenverarbeitung</h3>
        <p>Die erhobenen Daten werden ausschließlich zur Bearbeitung Ihres Einbürgerungsantrags nach § 10 ff. StAG verwendet. Die Rechtsgrundlage bildet Art. 6 Abs. 1 lit. e DSGVO in Verbindung mit dem Staatsangehörigkeitsgesetz (StAG) und dem Berliner Datenschutzgesetz (BlnDSG).</p>
      </div>

      <div class="legal-block">
        <h3 class="legal-block__title">Speicherdauer</h3>
        <p>Ihre Daten werden für die Dauer des Einbürgerungsverfahrens gespeichert. Nach Abschluss des Verfahrens werden die Daten entsprechend der gesetzlichen Aufbewahrungsfristen archiviert und anschließend gelöscht.</p>
      </div>

      <div class="legal-block">
        <h3 class="legal-block__title">Ihre Rechte</h3>
        <p>Sie haben das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16 DSGVO), Einschränkung der Verarbeitung (Art. 18 DSGVO) und Widerspruch (Art. 21 DSGVO). Darüber hinaus haben Sie das Recht, sich bei der Berliner Beauftragten für Datenschutz und Informationsfreiheit zu beschweren.</p>
        <p class="legal-contact">Berliner Beauftragte für Datenschutz und Informationsfreiheit<br/>
        Friedrichstr. 219, 10969 Berlin &nbsp;|&nbsp; datenschutz@datenschutz-berlin.de</p>
      </div>
    </div>

    <div class="form-section">
      <h3 class="section-title">Bestätigung <span class="required-mark">*</span></h3>
      <label class="checkbox-label" :class="{ checked: modelValue.confirm_datenschutz }">
        <input
          type="checkbox"
          class="checkbox-input"
          :checked="modelValue.confirm_datenschutz"
          @change="update('confirm_datenschutz', $event.target.checked)"
        />
        Ich habe die Datenschutzerklärung zur Kenntnis genommen und bin mit der Verarbeitung meiner personenbezogenen Daten zum Zweck der Bearbeitung meines Einbürgerungsantrags einverstanden. <span class="required-mark">*</span>
      </label>
      <p v-if="showErrors && !modelValue.confirm_datenschutz" class="field__error" style="margin-top:6px">
        ⚠ Bitte bestätigen Sie die Datenschutzerklärung, um fortzufahren.
      </p>
    </div>

    <p class="required-note"><span class="required-mark">*</span> Pflichtfelder</p>
  </div>
</template>

<script>
export default {
  name: 'NatStep1',
  props: {
    modelValue: { type: Object, required: true },
    showErrors: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const update = (key, val) => emit('update:modelValue', { ...props.modelValue, [key]: val });
    return { update };
  },
};
</script>

<style scoped src="../form.css"></style>
